module.exports = __webpack_public_path__ + "static/media/FoodDriveCover.e4e5966b.png";